import api from "../axios";
import type { SuppliersResponse } from "../types";

export const suppliersApi = {
  baseKey: ["suppliers"],

  getSuppliersQueryOptions: (params?: {
    offset?: number;
    limit?: number;
    sort_by?: string;
    order?: "ASC" | "DESC";
  }) => {
    const queryKey = [...suppliersApi.baseKey, "list", params];

    return {
      queryKey,
      queryFn: async ({
        signal,
      }: {
        signal?: AbortSignal;
      }): Promise<SuppliersResponse> => {
        const url = params
          ? `/suppliers?${new URLSearchParams(params as Record<string, string>)}`
          : "/suppliers";
        const response = await api.get<SuppliersResponse>(url, { signal });
        return response.data;
      },
    };
  },

  leaveSupplier: async (supplierId: string) => {
    const response = await api.post<string>(`/suppliers/${supplierId}/leave`);
    return response.data;
  },
};
